import { createI18n } from 'vue-i18n';
import ja from './ja.json';
import en from './en.json';

// localStorageから言語設定を取得、なければ.envファイルから、それもなければ'en'
const getLocale = () => {
  if (typeof window !== 'undefined') {
    const savedLocale = localStorage.getItem('app-locale');
    if (savedLocale && (savedLocale === 'ja' || savedLocale === 'en')) {
      return savedLocale;
    }
  }
  return process.env.VUE_APP_LANG || 'ja';
};

const defaultLocale = getLocale();

export const i18nConfig = {
  locale: defaultLocale, // デフォルトの言語
  fallbackLocale: 'ja', // フォールバック言語
  messages: {
    ja,
    en,
  },
  css: `lang-${defaultLocale}`,
  legacy: false, // Composition APIを使用する場合はfalse
  globalInjection: true, // テンプレート内で$t()を使用するために必要
};

const i18n = createI18n(i18nConfig);

export default i18n;

